import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./MessageModal.scss";

export const MessageModal = (props: any) => {
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const closeModal = () => {
    window.location.search = "";
    setOpenSuccessModal(false);
  };

  useEffect(() => {
    setOpenSuccessModal(props.open);
  }, [props.open]);

  return (
    <Modal
      show={openSuccessModal}
      onHide={() => setOpenSuccessModal(false)}
      className="message-modal"
      centered
    >
      <Modal.Header>
        <Modal.Title className="message-modal-title">
          Recebemos suas informações!
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="message-modal-message">
        Entraremos em contato o mais breve possível!
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="message-modal-buttom"
          variant="success"
          onClick={() => closeModal()}
        >
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
